import { useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';
import type { PlaceImportFromGmapsResponse } from '@upme/contracts';
import { useState } from 'react';
import { listCitiesOptions } from '../../../features/cities/queries';
import { useAdminPlaceCategories } from '../../../features/places/api/place-categories.queries';
import { PlaceForm } from '../../../features/places/components/place-form';
import { PlaceImportField } from '../../../features/places/components/place-import-field';
import { prefillToFormValues } from '../../../features/places/lib/prefill-to-form-values';
import { PageHeader } from '../../../shared/components/page-header';

type PrefillData = Extract<PlaceImportFromGmapsResponse, { kind: 'prefill' }>;

export const Route = createFileRoute('/_authenticated/places/new')({
  staticData: { breadcrumb: 'Новое' },
  loader: ({ context }) => context.queryClient.ensureQueryData(listCitiesOptions()),
  component: NewPlacePage,
});

function NewPlacePage() {
  const { data: cities } = useSuspenseQuery(listCitiesOptions());
  const cats = useAdminPlaceCategories();
  const [prefill, setPrefill] = useState<PrefillData | null>(null);

  return (
    <div>
      <PageHeader title="Новое место" />
      <PlaceImportField onPrefill={setPrefill} />
      <PlaceForm
        key={prefill?.googlePlaceId ?? 'empty'}
        mode="create"
        cities={cities}
        categories={cats.data ?? []}
        {...(prefill ? { initialValues: prefillToFormValues(prefill) } : {})}
        {...(prefill?.coverPreviewUrl ? { importedCoverPreviewUrl: prefill.coverPreviewUrl } : {})}
        {...(prefill?.coverStorageKey ? { importedCoverStorageKey: prefill.coverStorageKey } : {})}
      />
    </div>
  );
}
